import { gql } from "@apollo/client";

export const LOAD_RESERVATION_OFFER_OPTION_RATE_PLAN = gql`
  mutation loadReservationOfferOptionWithRatePlan(
    $loadReservationOfferOptionInput: LoadReservationOfferOptionInput!
    $from: Date!
    $until: Date!
  ) {
    loadReservationOfferOption(input: $loadReservationOfferOptionInput) {
      language
      reservationOfferOption {
        accommodations {
          id
          ratePlan {
            id
            name
            isAvailable(from: $from, until: $until)
            description
            occupancy
            mealType
            rateSellMode
            isArchived
            lowestPrice(from: $from, until: $until)
            defaultPriceBreakdown(until: $until, from: $from) {
              discountPercentage
              withoutDiscount
              withDiscount
            }
          }
        }
      }
    }
  }
`;
